import { render, staticRenderFns } from "./BannerPreview.vue?vue&type=template&id=6ab84b91&scoped=true"
import script from "./BannerPreview.vue?vue&type=script&lang=js"
export * from "./BannerPreview.vue?vue&type=script&lang=js"
import style0 from "./BannerPreview.vue?vue&type=style&index=0&id=6ab84b91&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab84b91",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ab84b91')) {
      api.createRecord('6ab84b91', component.options)
    } else {
      api.reload('6ab84b91', component.options)
    }
    module.hot.accept("./BannerPreview.vue?vue&type=template&id=6ab84b91&scoped=true", function () {
      api.rerender('6ab84b91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/components/BannerPreview.vue"
export default component.exports